import useSWR from 'swr';
import api from '../services/api';
import { Notification } from '../types/notifications';

interface UseNotificationsOptions {
  type?: string;
  read?: boolean;
  limit?: number;
}

export function useNotifications(options: UseNotificationsOptions = {}) {
  const { type, read, limit } = options;
  const params = new URLSearchParams();
  if (type) params.append('type', type);
  if (read !== undefined) params.append('read', String(read));
  if (limit) params.append('limit', String(limit));

  const { data, error, isLoading, mutate } = useSWR<Notification[]>(
    `/notifications${params.toString() ? `?${params.toString()}` : ''}`,
    async (url: string) => {
      const response = await api.get(url);
      return response.data;
    },
    {
      refreshInterval: 30000, // Refresh every 30 seconds
      revalidateOnFocus: true,
    }
  );

  return {
    notifications: data || [],
    isLoading,
    isError: error,
    mutate,
  };
}

export function useUnreadCount() {
  const { data, error, isLoading, mutate } = useSWR<number>(
    '/notifications/unread-count',
    async (url: string) => {
      const response = await api.get(url);
      return response.data;
    },
    {
      refreshInterval: 30000, // Refresh every 30 seconds
      revalidateOnFocus: true,
    }
  );

  return {
    count: data || 0,
    isLoading,
    isError: error,
    mutate,
  };
}

export async function markAsRead(notificationId: number): Promise<void> {
  await api.patch(`/notifications/${notificationId}/read`);
}

export async function markAllAsRead(): Promise<void> {
  await api.patch('/notifications/mark-all-read');
}

export async function deleteNotification(notificationId: number): Promise<void> {
  await api.delete(`/notifications/${notificationId}`);
}
